import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import { getLocalConfig } from './storageHelper';
import { getStore } from './store';
import { getDefaultConfig, resolveTheme } from './utils';
import singleton from 'vars-singleton';
export var defaultContextValue = {
  schema: '',
  config: {},
  dataMap: new Map(),
  setTheme: function setTheme() {},
  fetchThemeData: function fetchThemeData() {},
  resolvedTheme: {},
  styleCounts: {},
  setResolvedTheme: function setResolvedTheme() {}
};
function getDefaultContextValue() {
  var local = getLocalConfig();
  var store = getStore();
  var themeValue = {};
  var resetDefault = function resetDefault() {
    if (!Object.keys(themeValue || {}).length) {
      var _ref = store.state.themes.get(local.schema) || {
          data: {}
        },
        curData = _ref.data,
        surLoadData = _ref.loadData;
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _curData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!surLoadData) {
                  _context.next = 6;
                  break;
                }
                _context.next = 3;
                return surLoadData();
              case 3:
                _curData = _context.sent;
                _context.next = 7;
                break;
              case 6:
                _curData = curData;
              case 7:
                themeValue = resolveTheme(_curData, getDefaultConfig(_curData));
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
  var unListen = function unListen() {}; // 只需要执行一次

  unListen = store.subscribe(function () {
    resetDefault();
    if (unListen) {
      unListen();
      unListen = null;
    }
  });
  var defaultValue = _objectSpread(_objectSpread({}, defaultContextValue), local);
  Object.defineProperties(defaultValue, {
    resolvedTheme: {
      get: function get() {
        // resetDefault();
        return themeValue;
      },
      set: function set(value) {
        themeValue = value;
      }
    },
    originTheme: {
      get: function get() {
        // resetDefault();
        return themeValue;
      },
      set: function set(value) {
        themeValue = value;
      }
    }
  });
  return defaultValue;
}
var ThemeContext = singleton('__UED_THEME_CONTEXT__', React.createContext(getDefaultContextValue()));
var ThemeProvider = ThemeContext.Provider,
  ThemeConsumer = ThemeContext.Consumer;
export default ThemeContext;
export { ThemeConsumer, ThemeProvider, ThemeContext };